const BEDBANK_BOARD_CODE_LABELS: Record<App.RateBoardCode, string> = {
  roomonly: 'Room only',
  breakfast: 'Breakfast',
  halfboard: 'Half board',
  fullboard: 'Full board',
  allinclusive: 'All inclusive',
  LE: 'Package',
}

export function getBedbankBoardCodeLabel(boardCode: App.RateBoardCode): string {
  return BEDBANK_BOARD_CODE_LABELS[boardCode] ?? BEDBANK_BOARD_CODE_LABELS.LE
}

/**
 * Resolves the display name for a unified property rate.
 * `UnifiedRate.name` is canonical in contract v20+; on older contracts it may be absent
 * (deprecated for LPC) — fall back to LPC meta name, then bedbank board label.
 */
export function resolvePropertyRateName(options: {
  name?: string
  lpcMetaName?: string
  bedbankBoardCode?: App.RateBoardCode
}): string {
  if (options.name) {
    return options.name
  }

  if (options.lpcMetaName) {
    return options.lpcMetaName
  }

  if (options.bedbankBoardCode) {
    return getBedbankBoardCodeLabel(options.bedbankBoardCode)
  }

  return 'Package'
}

/**
 * Human-readable label for a property rate group (board + inclusions).
 */
export function getPropertyRateDisplayName(rate: App.PropertyRate): string {
  return resolvePropertyRateName({
    name: rate.name,
    bedbankBoardCode: rate.type === 'bedbank' ? rate.bedbankBoardCode : undefined,
  })
}
